export const environment = {
  production: true,
  ENV: 'prd',
  VERSION: 'v4.116.4',

  BASE_API: 'https://api.blanco.cloud/bids',

  BUGSNAG_API: '7d12d0cd2ec76ff6a85eb9d0fa7cc757',
};
